<template>
  <div>
    <div class="modal-mask" v-if="this.loadingStatus === 3">
      <br>
      <p class="text-center">RESULTS</p>

      <v-container justify="center">
        <v-row justify="center">
          <p v-on:mouseover="mouseOverAction" v-on:mouseleave="mouseLeaveAction">
            <a v-if="!hoverFlag">
              <img v-bind:src="this.imgDict['resized'].image" >
            </a>
            <a v-if="hoverFlag">
              <img v-bind:src="this.imgDict['processed'].image" >
            </a>
          </p>
        </v-row>
      </v-container>

      <v-container>
        <v-list>
          <v-list-item v-for="[key, data] of Object.entries(this.imgDict) " :key="data.path">
            <v-list-item-content>
              <a :href="data.image" target=”_blank”>
                <v-list-item-title v-text="key"></v-list-item-title>
              </a>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-img :src="data.image"></v-img>
            </v-list-item-avatar>
          </v-list-item>
        </v-list>

        <br>
        <br>
        <v-row justify="center">
          <router-link to="/" >Home</router-link>
        </v-row>
      </v-container>

    </div>

    <div class="modal-mask" v-if="this.loadingStatus !== 3">
      <v-container fill-height>
        <v-row justify="center" align="center">
          <vue-loading type="spin" color="#333" :size="{ width: '75px', height: '75px'}"></vue-loading>
        </v-row>
      </v-container>

      <div class="modal-mask" v-if="this.loadingStatus === 1">
        <p class="text-center">Uploading...</p>
      </div>

      <div class="modal-mask" v-if="this.loadingStatus === 2">
        <p class="text-center">Processing...</p>
      </div>
    </div>
  </div>
  
</template>

<script>
import { API, graphqlOperation, Storage } from 'aws-amplify';
import { listAppsyncImages } from "../graphql/queries";
import { onCreateAppsyncImage } from "../graphql/subscriptions";
import { VueLoading } from 'vue-loading-template';

const dataExpireSeconds = (30 * 60);
export default {
  name: 'Result',
  components: {
    VueLoading
  },
  data: () => ({
    group: null, 
    imgDict: {
      'source': { path : '', image : '' },
      'resized': { path : '', image : '' },
      'processed': { path : '', image : '' }
    },
    hoverFlag: false,
    loadingStatus: 1,
  }), 
  mounted: async function() {
    this.getList();
  }, 
  methods:{
    async getList() {
      this.group = this.$route.query.group;
      console.log("group : " + this.group);
      if(!this.group){
          return;
      }

      let apiResult = await API.graphql(graphqlOperation(listAppsyncImages, { group : this.group }));
      let listAll = apiResult.data.listAppsyncImages.items;
      for(let imgData of listAll) {
        this.appendImage(imgData);
      }

      API.graphql(
          graphqlOperation(onCreateAppsyncImage, { group : this.group } )
      ).subscribe({
          next: (eventData) => {
            let imgData = eventData.value.data.onCreateAppsyncImage;
            this.appendImage(imgData);
          }
      });
    }, 
    async appendImage(imgData) {
      let singleImgInfo = { path : imgData.path, filename: imgData.path.split('/').slice(-1)[0], image : "" };
      this.appendImgDictByPath(singleImgInfo);

      Storage.get(imgData.path.replace('public/', ''), { expires: dataExpireSeconds }).then(result => {
        singleImgInfo.image = result;
        this.appendImgDictByPath(singleImgInfo);
      }).catch(err => console.log(err));
    },
    async appendImgDictByPath(singleImgInfo) {
      if (singleImgInfo.path.includes("/processed_")) {
        this.imgDict["processed"] = singleImgInfo
      } else if (singleImgInfo.path.includes("/resized_")) {
        this.imgDict["resized"] = singleImgInfo
      } else {
        this.imgDict["source"] = singleImgInfo
        this.loadingStatus = 2;
      }
      if (this.imgDict["processed"].image && this.imgDict["source"].image && this.imgDict["resized"].image) {
        this.loadingStatus = 3;
      }
    },
    mouseOverAction(){
      this.hoverFlag = true
    },
    mouseLeaveAction(){
      this.hoverFlag = false
    }
  }
}
</script>